import { render, staticRenderFns } from "./link-list.vue?vue&type=template&id=408f2b97&"
import script from "./link-list.vue?vue&type=script&lang=ts&"
export * from "./link-list.vue?vue&type=script&lang=ts&"
function injectStyles (context) {
  
  var style0 = require("./link-list.vue?vue&type=style&index=0&id=408f2b97&prod&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports